<template>
	<div class="free-sticky">
		<span>{{ alertTitle }}</span>
	</div>
	<header class="app-header-new">
		<div class="header-center">
			<input type="text" placeholder="Rechercher..." class="searchbar" v-model="searchQuery"
				@input="onSearchInput" />
			<i class="bi bi-search search-icon"></i>
		</div>
		<span class="separator"></span>
		<div class="header-right">
			<i class="bi bi-bell" style="display: none"></i>
			<div class="user-info" ref="userPanel">
				<div class="top" @click="togglePanel">
					<p style="text-overflow: ellipsis">{{ user.firstname }} {{ user.lastname }}</p>
					<!-- <i :class="['bi', isPanelOpen ? 'bi-chevron-up' : 'bi-chevron-down']"></i> -->
				</div>
				<div class="bottom" @click="togglePanelProp">
					<p>{{ this.currentProperty.name }}</p>
					<i :class="['bi', isPanelPropOpen ? 'bi-caret-down-fill' : 'bi-caret-right-fill']"></i>
				</div>
			</div>
			<div v-if="isPanelOpen" class="user-panel">
				<!-- <p @click="profil">Mon Profil</p>
                <p>Paramètres</p> -->
				<p @click="logout">Se déconnecter</p>
			</div>
			<div v-if="isPanelPropOpen" class="prop-panel">
				<p v-for="property in properties" :key="property.id"
					:class="property.name === this.currentProperty.name ? 'current' : ''"
					@click="fetchProperty(property.ID)">
					{{ property.name }}
				</p>
				<hr />
				<router-link to="/mes-logements">Voir tous mes cils</router-link>
			</div>
		</div>
	</header>
</template>

<script>
export default {
	name: "AppHeader",
	props: ["currentProperty", "user"],
	data() {
		return {
			isPanelOpen: false,
			isPanelPropOpen: false,
			searchQuery: '',
			properties: {},
			showAlert: false,
			alertTitle: '',
			timer: null,
		};
	},
	created() {
		this.fetchAllProperties();
	},
	mounted() {
		window.addEventListener("click", this.handleWindowClick);
		this.fetchSubscriptionStatus();
	},
	methods: {
		onSearchInput() {
			this.$emit('search', this.searchQuery);
		},
		async fetchProperty(id) {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "logements/" + id, { method: "GET", credentials: "include", });
				const data = await response.json();
				if (data.error) {
					window.location.href = "/login";
				} else {
					localStorage.setItem("currentProperty", JSON.stringify(data));
					window.location.reload();
				}
			} catch (error) {
				this.message = "Une erreur est survenue.";
			}
		},
		async fetchAllProperties() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "logements", { method: "GET", credentials: "include", });
				const data = await response.json();
				if (data.error) return window.location.href = "/login";

				this.properties = data;
			} catch (error) {
				this.message = "Une erreur est survenue.";
			}
		},
		togglePanel() {
			this.isPanelOpen = !this.isPanelOpen;
			if (this.isPanelPropOpen) this.isPanelPropOpen = !this.isPanelPropOpen;
		},
		togglePanelProp() {
			this.isPanelPropOpen = !this.isPanelPropOpen;
			if (this.isPanelOpen) this.isPanelOpen = !this.isPanelOpen;
		},
		async profil() {
			this.$router.push(`/app/profil`);
			this.isPanelOpen = !this.isPanelOpen;
		},
		async logout() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "user/logout", { method: "GET", credentials: "include", });
				console.log(response.ok);
				if (response.ok) {
					this.$router.push("/login");
				} else {
					alert("Échec de la déconnexion");
				}
			} catch (error) {
				console.error("Erreur lors de la déconnexion:", error);
				alert("Erreur lors de la déconnexion");
			}
		},
		handleWindowClick(event) {
			if (this.$refs.userPanel && !this.$refs.userPanel.contains(event.target)) {
				this.isPanelOpen = false;
				this.isPanelPropOpen = false;
			}
		},
		async fetchSubscriptionStatus() {
			try {
				let currentProperty = JSON.parse(localStorage.getItem('currentProperty'));

				if (!currentProperty) {
					const checkPropertyInterval = setInterval(async () => {
						currentProperty = JSON.parse(localStorage.getItem('currentProperty'));

						if (currentProperty) {
							clearInterval(checkPropertyInterval);
							await this.fetchSubscriptionStatus();
						}
					}, 1000);
					return;
				}

				if (currentProperty && currentProperty.stripe_ID) {
					const stripe_ID = currentProperty.stripe_ID;

					const response = await fetch(process.env.VUE_APP_API_URL + 'user/subscription', {
						method: 'POST',
						credentials: "include",
						headers: { 'Content-Type': 'application/json', },
						body: JSON.stringify({ subID: stripe_ID }),
					});

					if (!response.ok) throw new Error('Erreur lors de la récupération de la souscription.');

					const data = await response.json();


					if (data?.status === 'trialing') {
						this.startCountdown(data.trial_end);
					} else if (data?.status === 'active') {
						this.showAlert = false;
						this.clearCountdown();
					} else {
						return this.$router.push(`/mes-logements`);
					}
				} else {
					console.error('Aucune propriété sélectionnée ou stripe_ID manquant.');
				}
			} catch (error) {
				console.error('Erreur:', error);
			}
		},
		startCountdown(trialEnd) {
			this.clearCountdown();

			this.timer = setInterval(() => {
				const currentTime = Math.floor(Date.now() / 1000);
				const timeRemaining = trialEnd - currentTime;

				if (timeRemaining > 0) {
					const days = String(Math.floor(timeRemaining / 86400)).padStart(2, '0');
					const hours = String(Math.floor((timeRemaining % 86400) / 3600)).padStart(2, '0');
					const minutes = String(Math.floor((timeRemaining % 3600) / 60)).padStart(2, '0');
					const seconds = String(timeRemaining % 60).padStart(2, '0');

					this.alertTitle = `Fin de l'essai dans : J-${days} ${hours}:${minutes}:${seconds}`;
					this.showAlert = true;
				} else {
					this.alertTitle = "La période d'essai est terminée.";
					this.clearCountdown();
				}
			}, 1000);
		},
		clearCountdown() {
			if (this.timer) {
				clearInterval(this.timer);
				this.timer = null;
			}
		},
	},
	beforeUnmount() {
		window.removeEventListener("click", this.handleWindowClick);
	},
	watch: {
		$route() {
			this.fetchAllProperties();
		},
	},
};
</script>

<style scoped>
.app-header-new {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 50px;
	color: white;
	gap: 50px;
}

.header-center {
	flex-grow: 1;
	display: flex;
	align-items: center;
}

.searchbar {
	padding: 20px;
	border: none;
	border-radius: 15px;
	width: 100%;
	box-sizing: border-box;
}

.search-icon,
.notification-icon,
.arrow-down-icon {
	cursor: pointer;
}

.search-icon {
	margin-left: -30px;
}

.header-right {
	position: relative;
	display: flex;
	align-items: center;
	flex-shrink: 0;
	gap: 50px;
}

.header-right i {
	font-size: 20px;
}

.separator {
	height: 50px;
	width: 2px;
	background-color: #c7c7c7;
}

.notification-icon {
	margin-right: 20px;
}

.user-info {
	white-space: nowrap;
	overflow: hidden;
	/* text-overflow: ellipsis; */
	max-width: 200px;
	cursor: pointer;
}

.user-info .top,
.user-info .bottom {
	display: flex;
	gap: 5px;
}

.user-info .bottom {
	justify-content: flex-end;
}

.user-info .top p,
.user-info .bottom p {
	color: #000;
	font-size: 18px;
	font-weight: bold;
	user-select: none;
	margin: 0;
	max-width: 180px;
	overflow: hidden;
}

.user-info .bottom p {
	color: #359590;
	font-size: 14px;
	margin-top: 2px;
}

.user-info .bottom i {
	color: #359590;
}

i {
	color: #000;
}

.user-panel,
.prop-panel {
	position: absolute;
	right: 0;
	top: 30px;
	background-color: white;
	border-radius: 5px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	padding: 10px;
	width: 200px;
	z-index: 10;
	overflow: hidden;
}

.prop-panel {
	top: 60px;
}

.user-panel p,
.prop-panel p {
	color: #333;
	padding: 10px;
	margin: 0;
	cursor: pointer;
}

.user-panel p:hover {
	background-color: #f0f0f0;
}

.prop-panel p {
	font-weight: bold;
	color: #359590;
	text-align: right;
}

.prop-panel p.current {
	position: relative;
	color: #fff;
	z-index: 1;
}

.prop-panel p.current:hover {
	background: none;
}

.prop-panel p.current::before {
	content: "";
	position: absolute;
	background-color: #359590;
	height: 32px;
	width: 220px;
	top: 5px;
	left: -10px;
	z-index: -1;
}

.prop-panel p:hover {
	position: relative;
	color: #fff;
	z-index: 1;
}

.prop-panel p:not(.current):hover::before {
	content: "";
	position: absolute;
	background-color: #359590;
	height: 32px;
	width: 220px;
	top: 5px;
	left: -10px;
	z-index: -1;
	opacity: 0.8;
}

.prop-panel hr {
	border: solid 1px #dcdcdc;
	width: 220px;
	margin-left: -11px;
}

.prop-panel a {
	font-weight: bold;
	color: #dcdcdc;
	display: block;
	text-align: right;
	text-decoration: none;
}

@media (max-width: 950px) {
	.app-header-new {
		padding: 10px;
		padding-left: 56px;
		gap: 10px;
	}

	.header-right {
		gap: 10px;
	}

	.searchbar {
		padding: 10px;
	}

	.user-info {
		max-width: 100px;
	}
}
</style>
